let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1rMtp")).then(() => parcelRequire('iBcm9'));